import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { ImageCarousel } from '../../image-carousel/image-carousel.component';
import { toys } from '../../../interfaces/toys';
import { TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-toys',
  standalone: true,
  imports: [MatCardModule,
    MatGridListModule,
    CommonModule,
    MatButtonModule,
    TranslatePipe],
  templateUrl: './toys.component.html',
  styleUrl: './toys.component.scss'
})
export class ToysComponent {

  constructor(public dialog: MatDialog) { }

  openDialog(castle: toys): void {
    this.dialog.open(ImageCarousel, {
      maxHeight: '480px',
      maxWidth: '800px',
      autoFocus: false,
      data: castle
    });
  }

  toys: toys[] = [
    {
      name: "toys.goal-wall",
      size: "4m x 3,5m x 2,5m",
      price: "130",
      fraction: "00",
      inclusive: "toys.inclusive",
      img: ["Torwand.png"]
    },
    {
      name: "toys.4-wins",
      size: "1,2m x 0,42m x 1,04m",
      price: "30",
      fraction: "00",
      img: ["4Gewinnt.png"]
    },
    {
      name: "toys.fortune-wheel",
      size: "1,42m x 0,42m, 0,1m",
      price: "30",
      fraction: "00",
      img: ["Gluecksrad.png"]
    }
  ];
}
